// LA DATA DELL'OFFERTA, SCRITTA UNA VOLTA SOLA (2026-09-13).
//
// "fino al 13 settembre" era testo scritto a mano in quattro chiavi di
// traduzione. Ha sbagliato due volte nello stesso giorno: la prima quando
// l'offerta e' scaduta, la seconda quando e' stata prorogata al 20 e la
// scritta continuava a dire 13. Finche' e' testo, tornera' sbagliata a ogni
// spostamento — e chi sposta la data e' il server, non chi scrive le
// traduzioni.
//
// Adesso la data arriva dal server insieme al prezzo (offerta1tbFine, che e'
// OFFERTA_1TB_FINE: la stessa costante che decide quale prezzo si paga) e qui
// si formatta nella lingua di chi guarda. Prezzo e scritta non possono piu'
// divergere, perche' vengono dallo stesso numero.

/**
 * "20 settembre" in italiano, "September 20" in inglese.
 *
 * ORA DI ROMA, non UTC: la scadenza e' fissata alle 23:59:59 italiane, che in
 * UTC sono le 21:59:59 dello stesso giorno — ma per una scadenza a
 * mezzanotte esatta UTC direbbe il giorno dopo. L'offerta e' annunciata in
 * ora italiana, quindi va letta in ora italiana.
 */
export function giornoDellaScadenza(iso, lingua) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  try {
    return new Intl.DateTimeFormat(lingua === 'en' ? 'en-GB' : lingua === 'es' ? 'es-ES' : lingua === 'fr' ? 'fr-FR' : lingua === 'de' ? 'de-DE' : 'it-IT', {
      day: 'numeric', month: 'long', timeZone: 'Europe/Rome',
    }).format(d);
  } catch {
    // Intl senza quel fuso (non dovrebbe succedere su nessun browser vivo):
    // meglio la data in UTC che nessuna data.
    return new Intl.DateTimeFormat(lingua === 'en' ? 'en-GB' : lingua === 'es' ? 'es-ES' : lingua === 'fr' ? 'fr-FR' : lingua === 'de' ? 'de-DE' : 'it-IT',
      { day: 'numeric', month: 'long' }).format(d);
  }
}

/**
 * Il giorno DOPO la scadenza: "dal 1 ottobre, 99".
 *
 * Stessa ragione della funzione qui sopra, e lo stesso fuso: la scadenza e'
 * alle 23:59:59 italiane, quindi il giorno dopo comincia un secondo dopo. Si
 * somma un giorno intero all'istante e si rilegge in ora di Roma, cosi' il
 * cambio di mese (30 settembre -> 1 ottobre) e l'ora legale li fa il
 * calendario, non io.
 */
export function giornoDopoLaScadenza(iso, lingua) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return giornoDellaScadenza(new Date(d.getTime() + 24 * 60 * 60 * 1000).toISOString(), lingua);
}
